












































import { FirstLoginStepEnum } from '../../enums';

import EpbButton from '../button.component.vue';
import Modal from '../modal.component.vue';
import Stepper from '../stepper.component.vue';

export default {
  name: 'epb-first-login-modal',
  components: {
    Modal,
    Stepper,
    EpbButton
  },
  computed: {
    steps: function (): string[] {
      return Object.values(FirstLoginStepEnum);
    },
    currentStep: function (): string {
      return this.steps[this.currentStepIndex];
    },
    previousStepActionText: function (): string {
      return (this.currentStepIndex === 0) ? this.messages.actions.exit : this.messages.actions.back;
    },
    nextStepActionText: function (): string {
      return (this.currentStepIndex === this.steps.length - 1) ? this.messages.actions.finish
        : this.messages.actions.next;
    }
  },
  data: function () {
    return {
      fullscreen: true,
      currentStepIndex: 0,
      messages: this.$epb.messages.app.firstLogin.modal
    };
  },
  methods: {
    getStepImageUrl: function (step: FirstLoginStepEnum): string {
      const fileName = {
        [FirstLoginStepEnum.INTRO]: () => 'intro',
        [FirstLoginStepEnum.USER_METRICS]: () => 'user-metrics',
        [FirstLoginStepEnum.NO_RESULTS_RATIO]: () => 'no-results-ratio',
        [FirstLoginStepEnum.CHECKOUT_RATIO]: () => 'checkout-ratio',
        [FirstLoginStepEnum.QUERIES_DISTRIBUTION]: () => 'queries-distribution',
        [FirstLoginStepEnum.GLOBAL_QUERIES]: () => 'global-queries',
        [FirstLoginStepEnum.COMPARISON_PERIODS]: () => 'comparison-periods',
        [FirstLoginStepEnum.MULTISELECTABLE_FILTERS]: () => 'multiselectable-filters'
      }[step]();
      return require(`../../assets/media/image/first-login/${ fileName }.gif`);
    },
    confirm: function (): void {
      this.$emit('confirm');
    },
    onStepChange: function (step: FirstLoginStepEnum): void {
      this.currentStepIndex = this.steps.indexOf(step);
    },
    onPreviousStepClick: function (): void {
      if (this.currentStepIndex === 0) {
        this.confirm();
      } else {
        this.currentStepIndex -= 1;
      }
    },
    onNextStepClick: function (): void {
      if (this.currentStepIndex === (this.steps.length - 1)) {
        this.confirm();
      } else {
        this.currentStepIndex += 1;
      }
    }
  }
};
